import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ComparativeSection() {
  const { t } = useTranslation('home');
  const rows = t('comparative.rows', { returnObjects: true }) as Array<{
    dimension: string;
    carta: string;
    consortium: string;
    financing: string;
  }>;

  return (
    <section className="bg-[#F6F2EC] py-24 border-t border-[#E7E1D9]">
      <div className="max-w-[1440px] mx-auto px-8 lg:px-16">
        <div className="max-w-[1080px] mx-auto">

          {/* Header */}
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
            <div>
              <p className="text-[11px] uppercase tracking-[0.12em] font-medium text-[#F97700] mb-4">
                {t('comparative.eyebrow')}
              </p>
              <h2 className="text-4xl font-semibold text-[#0B0B0B] leading-[1.2] mb-4">
                {t('comparative.title')}
              </h2>
              <p className="text-[15px] text-[#5A5248] leading-relaxed max-w-[520px]">
                {t('comparative.subtitle')}
              </p>
            </div>
            <Link
              to="/cartas-contempladas"
              className="flex-shrink-0 inline-flex items-center gap-2 text-[13px] font-medium text-[#0B0B0B] hover:text-[#F97700] transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              {t('comparative.cta')} <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Table */}
          <div className="bg-white border border-[#E7E1D9] rounded-lg overflow-hidden">
            {/* Column headers */}
            <div className="grid grid-cols-4 border-b border-[#E7E1D9]">
              <div className="p-5 border-r border-[#E7E1D9]">
                <span className="text-[10px] uppercase tracking-[0.1em] text-[#9A9288] font-medium">
                  {t('comparative.colDimension')}
                </span>
              </div>
              <div className="p-5 border-r border-[#E7E1D9] bg-[#FFF1E6]">
                <div className="flex items-center gap-2">
                  <i className="ri-file-check-line text-[#F97700] text-sm"></i>
                  <span className="text-[11px] font-semibold text-[#F97700] uppercase tracking-[0.06em]">
                    {t('comparative.colCarta')}
                  </span>
                </div>
              </div>
              <div className="p-5 border-r border-[#E7E1D9]">
                <span className="text-[11px] font-semibold text-[#0B0B0B] uppercase tracking-[0.06em]">
                  {t('comparative.colConsortium')}
                </span>
              </div>
              <div className="p-5">
                <span className="text-[11px] font-semibold text-[#0B0B0B] uppercase tracking-[0.06em]">
                  {t('comparative.colFinancing')}
                </span>
              </div>
            </div>

            {/* Rows */}
            {Array.isArray(rows) && rows.map((row, i) => (
              <div
                key={i}
                className={`grid grid-cols-4 border-b border-[#E7E1D9] last:border-b-0 ${
                  i % 2 === 0 ? 'bg-white' : 'bg-[#FAFAF8]'
                }`}
              >
                <div className="p-5 border-r border-[#E7E1D9] flex items-center">
                  <span className="text-[12px] font-semibold text-[#0B0B0B] uppercase tracking-[0.06em]">
                    {row.dimension}
                  </span>
                </div>
                <div className="p-5 border-r border-[#E7E1D9] bg-[#FFF1E6]/40">
                  <span className="text-[13px] text-[#2E2E2E] leading-relaxed">
                    {row.carta}
                  </span>
                </div>
                <div className="p-5 border-r border-[#E7E1D9]">
                  <span className="text-[13px] text-[#5A5248] leading-relaxed">
                    {row.consortium}
                  </span>
                </div>
                <div className="p-5">
                  <span className="text-[13px] text-[#5A5248] leading-relaxed">
                    {row.financing}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* Disclaimer */}
          <p className="text-[12px] text-[#9A9288] mt-6 leading-relaxed">
            <i className="ri-information-line mr-1"></i>
            {t('comparative.disclaimer')}
          </p>
        </div>
      </div>
    </section>
  );
}
